import { apiRequest, apiRequestAll } from './http'

export interface SalesDto {
  id: number | string
  submissionNo: string
  businessDate: string
  period: 'morning' | 'afternoon'
  storeId: number | string
  storeName: string
  submitterName: string
  submittedAt: string
  orderCount: number | string
  revenue: number | string
  cost: number | string
  received: number | string
  unsettled: number | string
  wechat: number | string
  alipay: number | string
  cash: number | string
  items?: Array<{ productId: number | string; quantity: number | string }>
}

export interface UnsettledDto {
  id: string | number
  orderNo: string
  businessDate: string
  storeId: string | number
  storeName: string
  period: 'morning' | 'afternoon'
  createdAt: string
  amount: string | number
  remark: string
  submitterName: string
}

export const salesApi = {
  list: () => apiRequestAll<SalesDto>('/sales'),
  unsettled: () => apiRequestAll<UnsettledDto>('/sales/unsettled-orders'),
  create: (body: unknown) => apiRequest('/sales', { method: 'POST', body, idempotent: true }),
  void: (id: number) => apiRequest(`/sales/${id}/void`, {
    method: 'POST', body: { reason: '老板在网页端作废' }
  }),
  settle: (id: string, body: unknown) => apiRequest(`/sales/unsettled-orders/${id}/settle`, { method: 'POST', body })
}
